import axios from "axios";
import { Constants } from "../utils/Constants";

export function getDataTable(events) {
  return axios.post(`${Constants.baseUrl}/usuarios/list`, events);
}

export function create(form) {
  return axios.post(`${Constants.baseUrl}/usuarios`, form);
}

export function get(id) {
  return axios.get(`${Constants.baseUrl}/usuarios/${id}`);
}

export function update(id, form) {
  return axios.post(`${Constants.baseUrl}/usuarios/${id}`, form);
}

export function destroy(id) {
  return axios.delete(`${Constants.baseUrl}/usuarios/${id}`);
}

export function updateEmail(email) {
  return axios.post(`${Constants.baseUrl}/usuarios/update-email`, { email });
}

export function getSimpleList(data) {
  return axios.post(`${Constants.baseUrl}/usuarios/simpleList`, data ?? null);
}

export function getSimpleListBarbeiro(data) {
  return axios.post(
    `${Constants.baseUrl}/usuarios/simpleListBarbeiro`,
    data ?? null
  );
}

export function getSimpleListBarbeirosAtivos(data) {
  return axios.post(
    `${Constants.baseUrl}/usuarios/simpleListBarbeirosAtivos`,
    data ?? null
  );
}

export function getServicosBarbeiroList(data) {
  return axios.post(`${Constants.baseUrl}/usuarios/servicos/list`, data);
}

export function getServicos(id, data = null) {
  return axios.post(`${Constants.baseUrl}/usuarios/servicos/${id}`);
}

export function handleIntervalos(data) {
  return axios.post(`${Constants.baseUrl}/usuarios/intervalos/handle`, data);
}

export function getListBarbeiros(events) {
  return axios.post(`${Constants.baseUrl}/usuarios/listOrdenada`, events);
}

export function setExibicaoProfissionais(data) {
  return axios.post(
    `${Constants.baseUrl}/usuarios/exibicao-profissionais`,
    data
  );
}

export function getPlanoUser(form) {
  return axios.post(`${Constants.baseUrl}/usuarios/plano-user`, form);
}

export function listAllToExport(data) {
  return axios.post(`${Constants.baseUrl}/usuarios/list-all`, data);
}

export function storeContrato(data) {
  return axios.post(`${Constants.baseUrl}/usuarios/contrato`, data);
}

export function deleteContrato(id) {
  return axios.delete(`${Constants.baseUrl}/usuarios/contrato/${id}`);
}
